import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-dt";

import api from "../../../api";
import DynamicBanner from "../../Pages/include/DynamicBanner";

const NoticeDataTable = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  const tableRef = useRef(null);
  const tableSectionRef = useRef(null);

  // Helper to construct full URL
  const getFileUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${process.env.REACT_APP_API_URL}/public${cleanPath}`;
  };

  // Helper for Banner Images
  const formatBannerPath = (path) => {
    if (!path) return null;
    return `/${path.replace(/^\//, "")}`;
  };

  // 1. Fetch Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(
          "/api/sitepages/academic/notices-circulars"
        );

        if (response.data && response.data.status) {
          const data = response.data.data;

          const processedBanner = {
            ...data.banner,
            desktop_images:
              data.banner.desktop_images
                ?.map(formatBannerPath)
                .filter(Boolean) || [],
            mobile_images:
              data.banner.mobile_images
                ?.map(formatBannerPath)
                .filter(Boolean) || [],
          };

          setPageData({ ...data, banner: processedBanner });
        }
      } catch (error) {
        console.error("Error fetching notices:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // 2. Initialize DataTable
  useEffect(() => {
    if (!loading && pageData?.content?.rows && tableRef.current) {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }

      const table = $(tableRef.current).DataTable({
        data: pageData.content.rows,
        paging: true,
        searching: true,
        info: true,
        lengthChange: true,
        responsive: true,
        order: [[2, "asc"]],
        pageLength: 10,
        language: {
          searchPlaceholder: "Search Notices...",
        },
        columns: [
          { data: "college" },
          { data: "title" },
          {
            data: "file_url",
            render: function (data) {
              return data
                ? `
                  <a href="${getFileUrl(
                    data
                  )}" target="_blank" rel="noopener noreferrer"
                     style="color:#345DAD;font-weight:600;text-decoration:none;">
                     <i class="fa fa-download" style="margin-right:5px;"></i> Click Here
                  </a>
                `
                : '<span style="color:#777;">No File</span>';
            },
          },
          { data: "formatted_date" },
        ],
      });

      /* ✅ SCROLL TO TABLE SECTION ON PAGINATION (MOBILE ONLY) */
      table.on("page.dt", function () {
        if (window.innerWidth <= 768 && tableSectionRef.current) {
          window.scrollTo({
            top: tableSectionRef.current.offsetTop - 60,
            behavior: "smooth",
          });
        }
      });
    }

    return () => {
      if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [loading, pageData]);

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (!pageData) return null;

  const { banner, content } = pageData;

  return (
    <>
      <DynamicBanner
        title={banner.title}
        bgImage={banner.desktop_images}
        bgImageMobile={banner.mobile_images}
      />

      <section className="mb-5 mt-5" ref={tableSectionRef}>
        <div className="container">
          <div className="sec-title text-center mb-4">
            <h2>{content.heading || "Notices and Circular"}</h2>
          </div>

          <div className="table-responsive">
            <table
              ref={tableRef}
              className="display table table-striped table-hover"
              style={{ width: "100%" }}
            >
              <thead style={{ background: "#4a5ea8", color: "white" }}>
                <tr>
                  {(content.headers || [
                    "College",
                    "Title",
                    "Download / Details",
                    "Publish Date",
                  ]).map((header, i) => (
                    <th
                      key={i}
                      style={{ color: "white", fontWeight: "600" }}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
};

export default NoticeDataTable;
